/*----------------------------------
- DEPENDANCES
----------------------------------*/

import { Lock } from 'lucide-preact';
import type { ProUnlockFeature } from '@/client/catalogs/proUnlock';
import { requestProUnlock } from './proUnlockEvents';

/*----------------------------------
- TYPES
----------------------------------*/

type Props = {
    id: string;
    label: string;
    icon: typeof Lock;
    feature: ProUnlockFeature;
    onNavigate?: () => void;
};

/*----------------------------------
- COMPONENT
----------------------------------*/

// A menu entry for something that comes with Pro: it stays where it will be, marked "Pro", and explains itself when pressed.
export default function ProLockedNavItem({ id, label, icon: Icon, feature, onNavigate }: Props) {
    return (
        <button
            type="button"
            onClick={() => {
                onNavigate?.();
                requestProUnlock({ feature });
            }}
            className="group flex w-full items-center gap-3 rounded-lg border-l-2 border-transparent px-3 py-2 text-left text-sm font-medium tracking-wide text-slate-500 transition-all duration-200 hover:bg-amber-50/60 hover:text-slate-800 active:scale-[0.98]"
            data-testid={`nav-locked-${id}`}
        >
            <Icon size={18} strokeWidth={1.5} className="shrink-0 text-slate-400 group-hover:text-amber-600" />
            <span className="flex-1 truncate">{label}</span>
            <span className="inline-flex shrink-0 items-center gap-1 rounded-full border border-amber-200 bg-amber-50 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-amber-700">
                <Lock size={10} aria-hidden="true" /> Pro
            </span>
        </button>
    );
}
